var n = "_icon_1q1xv_1",
  e = "_spinnerWrapper_fteeq_3",
  i = "_spinnerIcon_fteeq_11",
  o = {
    icon: n,
    spinnerWrapper: e,
    spinnerIcon: i,
    "loading-animation": "_loading-animation_fteeq_1"
  };
export { o as default, n as icon, i as spinnerIcon, e as spinnerWrapper };